export default function ReviewCard({
  key,
  reviewImg,
  reviewTitle,
  reviewDesc,
  reviewBgColor,
  reviewList,
  reviewCountry,
  reviewPlatform
}) {
  return (
    <div
      key={key}
      className={`review-card m-6 h-full lg:px-[40px] lg:py-[40px] p-6 rounded-2xl ${reviewBgColor} flex justify-start items-center xl:flex-row flex-col gap-8 mx-auto relative`}
    >
      <div className="order-2">
        <h3 className="text-white text-3xl font-medium leading-9 tracking-tight mb-4">
          {reviewTitle}
        </h3>        
        <p className="text-white text-sm font-normal leading-5 min-w-40 mb-6">
          {reviewDesc}
        </p>
        <div className="flex gap-6">
          <div>
            <h4 className="text-[13px] font-normal leading-5 text-white mb-1.5">Country</h4>
            <div className="flex gap-1.5">
              <img src="https://glocify.com/images/earth.png" alt="earth" className="w-[25px]"/>
              <h4 className="text-[15px] font-bold leading-6 text-white">{reviewCountry}</h4>
            </div>
          </div>
          <div>
            <h4 className="text-[13px] font-normal leading-5 text-white mb-1.5">Platform</h4>
            <div className="flex gap-1.5">
              {/* <img src="https://glocify.com/images/usa-flag.svg" alt="" /> */}
              <h4 className="text-[15px] font-bold leading-6 text-white">{reviewPlatform}</h4>
            </div>
          </div>
        </div>
        <div className="mt-[35px] mb-[30px] w-full h-[1px] bg-white/15"/>
        <div className="flex items-center gap-[14px] flex-wrap">
          {
            reviewList.map((list, index) => (
              <div key={index} className="border-l-4 border-solid border-white pl-3 py-1.5 pr-1.5 bg-[linear-gradient(90deg,rgba(245,245,245,0.41)_0%,rgba(143,143,143,0.41)_100%)]"><p className="text-[13px] font-normal leading-5 text-white">{list}</p></div>
            ))
          }         
        </div>
      </div>
      <div className="2xl:min-w-[396px] xl:min-w-[298px] 2xl:max-w-[396px] xl:max-w-[298px] min-w-[396px] max-w-[298px] flex items-center order-1">
        <img src={reviewImg} alt={reviewTitle} className="" />
      </div>
    </div>
  );
}
